<template>
  <fieldset class="tab tab-02 none-bg">
    <div class="heading-form a-center">
      <span class="number">2/10</span>
      <p class="c-yellow">สุขภาพทางการเงิน</p>
      <h2 class="heading-h2 c-white">
        ค่าใช้จ่ายประจำต่อเดือน<span class="br767">คิดเป็นกี่ % ของรายได้</span>
      </h2>
      <p class="desc">
        (ค่าน้ำ ค่าไฟ ค่าผ่อนบ้านและรถ
        ค่าใช้จ่ายที่ใช้ดูแลผู้ที่อยู่ภายใต้การอุปการะเลี้ยงดู)
      </p>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input h-label">
            <label for="" class="icw-label overlabel">ค่าใช้จ่าย</label>
            <InputPattern
              id="txtCostPercent"
              type="text"
              placeholder="ระบุจำนวน"
              v-model="expenses"
              maxlength="3"
              :regExp="/^[0\D]*|\D*/g"
              pattern="\d*"
            />
            <label for="" class="icw-label overlabel label-last">%</label>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-02', 'tab-01')"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      id="btnNextStepQ3"
      type="button"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>
  </fieldset>
</template>

<script>
import Vue from "vue";

import InputPattern from "vue-pattern-input";

import { my_storage } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";

export default {
  name: "QuestionStep2_Q2",
  components: {
    InputPattern
  },
  props: {
    QuestionType: String
  },
  data() {
    return {
      expenses:
        my_storage(this.QuestionType, "expenses") == ""
          ? 0
          : my_storage(this.QuestionType, "expenses")
    };
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    beforeNextStep() {
      if (this.expenses > 0) {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));
        this.nextStep("tab-02", "tab-03");
      }
    }
  },
  watch: {
    expenses: function(n, o) {
      if (n > 100) {
        this.$nextTick(() => {
          this.expenses = 100;
        });
      }
    }
  },
  computed: {
    isPass() {
      return this.expenses > 0;
    }
  }
};
</script>
